import React from "react";
import Main from "../components/main";

import OfferList from "../components/Offers/offer-list";
import OfferDetailPage from "../components/Offer-detail-page/offer-detail-page";

import { Route } from "react-router";

var routes = (
  <Route path="/" component={Main}>
    <Route path="/offers-and-coupons" component={OfferList} />
    <Route path="/offers-and-coupons/uae" component={OfferList} />
    <Route path="/offers-and-coupons/:offer" component={OfferDetailPage} />
  </Route>
);

export default routes;



// WEBPACK FOOTER //
// ./src/Routes/serverRoutes.js